<script>
  import ButtonCopyToClipboard from "../../../../lib/components/ButtonCopyToClipboard.svelte";
  let d = "\\d{}";
</script>

<ButtonCopyToClipboard text="&#92;" />
<ButtonCopyToClipboard text="|" />
<ButtonCopyToClipboard text="^" />
<ButtonCopyToClipboard text="^.*$" />
<ButtonCopyToClipboard text={d} />
